import { alpha, Box, useTheme } from '@mui/material';

export const TexturedBackground = () => {
  const theme = useTheme();
  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage:
            theme.palette.mode === 'dark'
              ? 'url(/background-light.svg)'
              : 'url(/background-dark.svg)',
          backgroundRepeat: 'repeat',
          backgroundSize: 'auto',
          backgroundPosition: '0 0',
          opacity: 0.4,
          zIndex: -2,
        }}
      />
      {/* Transparent gradient overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `linear-gradient(180deg, ${alpha(theme.palette.background.default, 1)} 0%, ${alpha(theme.palette.background.default, 0.8)} 50%, ${alpha(theme.palette.background.default, 0.6)} 100%)`,
          zIndex: -1,
        }}
      />
    </>
  );
};
